import axiosInstance from './axiosInstance';

export const getCartApi        = ()              => axiosInstance.get('/cart');
export const addToCartApi      = (data)          => axiosInstance.post('/cart', data);
export const updateCartItemApi = (itemId, qty)   => axiosInstance.patch(`/cart/${itemId}`, { quantity: qty });
export const removeCartItemApi = (itemId)        => axiosInstance.delete(`/cart/${itemId}`);
export const clearCartApi      = ()              => axiosInstance.delete('/cart/clear');
